import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ user, roles, allowedRoles }) => {
  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  if (allowedRoles && !roles.some((r) => allowedRoles.includes(r.id))) {
    return <Navigate to="/expired" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
